module.exports = __webpack_public_path__ + "assets/img/684b-kh.svg";